export default [
    {
        path: '/product',
        component: resolve => require(['../../views/product/index'], resolve),
        meta: { title: '产品' }
      },
      {
        path: '/productList',
        component: resolve => require(['../../views/product/productList'], resolve),
        meta: { title: '产品列表' }
      },
      {
        path: '/index',
        component: resolve => require(['../../views/product/index'], resolve),
        meta: { title: '产品列表' }
      },
      {
        path: '/addProduct',
        component: resolve => require(['../../views/product/add'], resolve),
        meta: { title: '新增产品' },
        name : 'ADDPRODUCT'
      },
      {
        path: '/productDetail',
        component: resolve => require(['../../views/product/productDetail'], resolve),
        meta: { title: '产品详情' }
      },{
        path: '/groupAndRecommend',
        component: resolve => require(['../../views/product/groupAndRecommend'], resolve),
        meta: { title: '分组推荐' }
      },{
        path: '/myProductList',
        component: resolve => require(['../../views/product/myProductList'], resolve),
        meta: { title: '我的产品' }
      },{
        path: '/moreProduct',
        component: resolve => require(['../../views/product/moreProduct'], resolve),
        meta: { title: '更多产品' }
      },
      {
        path: '/qzlibrary',
        component: resolve => require(['../../views/product/qzlibrary'], resolve),
        meta: { title: '签证签注资料库' }
      }
]



// WEBPACK FOOTER //
// ./src/SRM/router/modules/product.js